import dateFormat from "dateformat";
import { moscowNow } from "./moscowNow";

export const getPrevDate = (date: string): number => {
  const currentDay = new Date(Date.parse(date));
  return currentDay.setDate(currentDay.getDate() - 1);
};

export const getNextDate = (date: string): number => {
  const currentDay = new Date(Date.parse(date));
  return currentDay.setDate(currentDay.getDate() + 1);
};

export const formatPrevNextDate = (date: string): string => {
  return dateFormat(date, "ddd").toUpperCase();
};

export const isSeatTimesUp = (seatTime: string, currentDate: string): boolean => {
  const currentDay = new Date(Date.parse(currentDate)).getDate();
  const now = moscowNow();
  const nowDay = now.getDate();

  if (currentDay !== nowDay) return false;

  const seatHour = +seatTime.substring(0, 2);
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  // Прошлые часы — заблокированы
  if (seatHour < currentHour) return true;
  // Текущий час — доступен только первые 30 минут
  if (seatHour === currentHour) return currentMinutes >= 30;
  // Будущие часы — доступны
  return false;
};

export const isPrevDateDisabled = (date: string): boolean => {
  const prevDate = new Date(getPrevDate(date)).setHours(0, 0, 0, 0);
  const nowDate = moscowNow().setHours(0, 0, 0, 0);

  return prevDate < nowDate;
};

export const getPrevMonth = (date: string): number => {
  const current = new Date(Date.parse(date));
  current.setDate(1);
  current.setMonth(current.getMonth() - 1);
  return current.getTime();
};

export const getNextMonth = (date: string): number => {
  const current = new Date(Date.parse(date));
  current.setDate(1);
  current.setMonth(current.getMonth() + 1);
  return current.getTime();
};

export const isPrevMonthDisabled = (date: string): boolean => {
  const current = new Date(Date.parse(date));
  const now = moscowNow();
  return (
    current.getFullYear() === now.getFullYear() &&
    current.getMonth() === now.getMonth()
  );
};

export const formatCurrentDate = (date: string) => {
  return {
    dayName: dateFormat(date, "dddd"),
    date: dateFormat(date, "dd.mm.yyyy"),
    monthName: dateFormat(date, "mmmm"),
    yearName: dateFormat(date, "yyyy"),
  };
};

